import _ from 'lodash'
import Backbone from 'backbone'
import template from './date-filter-step1.hbs'
import formHelper from 'scoreboard/components/form-helper'
import i18n from 'scoreboard/components/i18n'
import dropdown from 'scoreboard/components/dropdown'
import DatasetDateFilterStep1 from 'scoreboard/datasets/filters/datasets-date-filter-step1'
import operatorOptions from 'scoreboard/datasets/filters/operator-options'
import OrFilterView from 'scoreboard/reports/common/filter/or-filter'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

/* Report Date Filter that is an adapter for the Datasets Date Filter which does the actual date filter
 * implementation
 */
const DatasetDateFilterStep1Adapter = Backbone.View.extend({

	className: 'report-filters',

	events: {
		'change [name=operator]': 'changeOperator'
	},

	initialize: function(options = {}) {
		this.options = options
		this.data = options.data || {}
		this.dateFilter = new DatasetDateFilterStep1(
			_.defaults(this.options, {filter: this.data}))
	},

	render: function () {
		let tmp = this.options.template || template
		this.$el.html(tmp(this.options))

		let options = operatorOptions(new Backbone.Model({dataType: DATE}))
		let operatorSelect = this.$('[name=operator]')
		dropdown.object(operatorSelect.empty(), options, this.data.operator)

		this.changeOperator()

		this.dateFilter.setElement(this.el)
		this.dateFilter.render()

		if (this.options.showOrFilter) {
			//setup the "OR"ing of filters
			this.orFilterView && this.orFilterView.remove()
			this.orFilterView = new OrFilterView(_.defaults({
				filter: this.data,
				meta: this.options.meta
			}, this.options))
			this.$('.or-filter-content').html(this.orFilterView.el)
			this.orFilterView.render()

			//wire the changes from the or filter
			this.listenTo(this.orFilterView, 'toggle change', this.formView.change.bind(this.formView))
		}

		return this
	},

	changeOperator: function(e) {
		this.trigger('change:operator', this.$('[name=operator]').val())
	},

	gather: function() {
		let val = {
			operator: this.$('[name=operator]').val()
		}
		_.extend(this.data, val, formHelper.readFromDom(this.el))
		if (this.orFilterView) {
			this.data.linkGroup = this.orFilterView.filter.linkGroup
		}
		return this.data
	},

	test: function() {
		if (this.orFilterView) {
			if (_.isNil(this.orFilterView.filter.linkGroup)) {
				return i18n.get('datasets.orGroup.required')
			}
		}
		return this.dateFilter.test()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dateFilter, this.orFilterView], 'remove')
	}

})

export default DatasetDateFilterStep1Adapter

DatasetDateFilterStep1Adapter.__filename__ = 'reports/common/filter/dataset-date-filter-step1-adapter.js'
